import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20beautiful%20artistic%20illustration%20collage%20with%20soft%20warm%20gradients%2C%20abstract%20geometric%20shapes%2C%20reading%20atmosphere%2C%20literary%20minimalist%20design%2C%20cream%20warm%20tones%2C%20subtle%20texture%2C%20elegant%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩国漫画推荐"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/55"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-primary-300 text-sm md:text-base font-medium mb-3 tracking-widest">
          发现你的下一部韩国漫画
        </p>
        <h1
          className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 leading-tight"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          好看的韩国漫画推荐
        </h1>
        <p className="text-background-200/90 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          精选<strong>好看的韩国漫画</strong>排行榜，涵盖<strong>免费韩国漫画</strong>大全、高分必看作品，
          在线看人气<strong>韩国漫画</strong>，发现你的下一部韩国漫画。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-7 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer no-underline whitespace-nowrap"
          >
            浏览全部漫画
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="#ranking"
            className="px-7 py-3 bg-background-50/15 text-background-50 backdrop-blur-sm rounded-full font-medium text-sm hover:bg-background-50/25 transition-all cursor-pointer no-underline whitespace-nowrap"
          >
            查看排行榜
            <i className="ri-trophy-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}